import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Radio({ id, Items, Selected, Reverse, onClick }) {
    const UI = useContext(Context_UI);

    const Item_WithIndex = Items.map((Item, index) => ({
        ...Item,
        Index: index
    }));
    const Items_Display = Reverse ? [...Item_WithIndex].reverse() : Item_WithIndex;

    return (
        <>
            <div className="Radio" id={id} Radio_ActiveButton={Selected != null ? Selected : ""}>
                {
                    Items_Display.map((Item) => (
                        <>
                            {onClick ? 
                                <button className="Radio_Button" onClick={() => {
                                    UI.Radio_Select(Item.ID);
                                    onClick();
                                }} id={Item.ID} State={Selected == Item.ID ? "Active" : "Inactive"} Index={Item.Index}>
                                    <div className="Radio_Button_Indicator"></div>
                                    <p className="Radio_Button_Text">
                                        {Item.Text}
                                    </p>
                                </button>
                                :
                                <button className="Radio_Button" onClick={() => {
                                    UI.Radio_Select(Item.ID)
                                }} id={Item.ID} State={Selected == Item.ID ? "Active" : "Inactive"} Index={Item.Index}>
                                    <div className="Radio_Button_Indicator"></div>
                                    <p className="Radio_Button_Text">
                                        {Item.Text}
                                    </p>
                                </button>
                            }
                            
                        </>

                    ))
                }
            </div>
        </>
    )
}

